exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control--23svo {\n  max-width: 260px;\n}\n\n.modal--1SIlJ {\n  max-width: 600px;\n}\n\n.modal-content--3FO0i {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.inputs--1cnAp {\n  max-width: 380px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.summary--losA6 {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--19Azr {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--19Azr .button--13-HC {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"control": "control--23svo",
	"modal": "modal--1SIlJ",
	"modal-content": "modal-content--3FO0i",
	"inputs": "inputs--1cnAp",
	"summary": "summary--losA6",
	"submit": "submit--19Azr",
	"button": "button--13-HC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-admin/Users/CreateProcRole/CreateRole.m.scss
// module id = 1594
// module chunks = 0